export const APP_ID = '531a79aba17a4';
export const REGION = 'us';
export const AUTH_KEY = 'bbdcac2445f27224f2d74bbebede56c9af2ec3ca';
export const WEB_APP_HOME = 'https://cometchat.pages.dev/';
export const WEB_APP_DYNAMIC_LINK = 'https://cometchat.page.link/?link=https://cometchat.pages.dev/__ID__&apn=com.reactnativecallingandroid';
export const WIDGET_ID = '70470a88-7f9e-4786-9dec-af41c3e6de11';
